import React, { Component } from 'react';
import 'whatwg-fetch';
import _ from 'lodash';
import AppContext from '../../AppContext';
import './consents.scss';

function withConsents(WrappedComponent) {
  class Consents extends Component {
    static contextType = AppContext;

    constructor(props) {
      super(props);

      this.state = {
        consentOfUsage: '',
        consentOfPrivacy: '',
        consentOfExternal: '',
        consents: {
          // dynamic consents from WrappedComponent
        },
        consentsDisplay: {
          usage: false,
          privacy: false,
          external: false
        },
        captchaVerified: false,
        captchaToken: ''
      };

      this.wrappedComponentRef = React.createRef();

      this.loadConsent = this.loadConsent.bind(this);

      this.onConsented = this.onConsented.bind(this);
      this.moveNext = this.moveNext.bind(this);
      this.onCaptchaLoad = this.onCaptchaLoad.bind(this);
      this.onCaptchaVerify = this.onCaptchaVerify.bind(this);
      this.onCaptchaExpired = this.onCaptchaExpired.bind(this);
    }

    onConsented(id) {
      const { consents } = this.state;
      consents[id] = !consents[id];

      this.setState({ consents });
    }

    update(params) {
      const { actions } = this.context;
      actions.setData(params);
    }

    async moveNext() {
      const {
        actions: { generateToken, generatePromotionToken, stepTo, setData },
        state: { sessionToken }
      } = this.context;
      const { captchaToken } = this.state;

      try {
        const generator = sessionToken ? generatePromotionToken : generateToken;
        const { data } = await generator({ captchaToken, sessionToken });

        this.update({
          transactionToken: data.accessToken
        });

        this.props.handleMoveNext();
      } catch (e) {
        console.warn(e.message);
        setData({
          hasError: true,
          shouldReset: true,
          errorDetail: '올바른 접근이 아니거나 입력 시간이 초과되었습니다.'
        });
      }
    }

    onCaptchaVerify(token) {
      this.setState({ captchaVerified: true, captchaToken: token });
    }

    onCaptchaExpired() {
      this.setState({ captchaVerified: false, captchaToken: '' });
    }

    onCaptchaLoad(e) {}

    loadConsent(url, callback) {
      fetch(url, {
        method: 'GET',
        cache: 'no-cache'
      })
        .then((response) => response.text())
        .then(callback);
    }

    componentDidMount() {
      const {
        actions: { api }
      } = this.context;

      this.loadConsent(api('/signup/v1/account/consent/usage'), (text) => this.setState({ consentOfUsage: text }));
      this.loadConsent(api('/signup/v1/account/consent/privacy'), (text) => this.setState({ consentOfPrivacy: text }));
      this.loadConsent(api('/signup/v1/account/consent/external'), (text) =>
        this.setState({ consentOfExternal: text })
      );
    }

    isAvailable() {
      const { captchaVerified, consents } = this.state;
      const agreedConsents = Object.keys(consents).filter((k) => consents[k] === true);
      const countConsents = this.wrappedComponentRef.current && this.wrappedComponentRef.current.childNodes.length;

      return captchaVerified && agreedConsents.length === countConsents;
    }

    render() {
      const {
        state: { recaptchaKey }
      } = this.context;

      const isAvailable = this.isAvailable();

      return (
        <WrappedComponent
          ref={this.wrappedComponentRef}
          moveNext={this.moveNext}
          onConsented={this.onConsented}
          recaptchaKey={recaptchaKey}
          isAvailable={isAvailable}
          onCaptchaVerify={this.onCaptchaVerify}
          onCaptchaExpired={this.onCaptchaExpired}
          onCaptchaLoad={this.onCaptchaLoad}
        />
      );
    }
  }

  const componentName = WrappedComponent.displayName || WrappedComponent.name;
  Consents.displayName = `logProps(${componentName})`;

  return Consents;
}

export default withConsents;
